import { useState, useContext, useEffect, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowRight, FaBolt } from "react-icons/fa";
import "../styles/electricity.css"; // ✅ Import custom CSS

const electricityServices = [
    { code: "IKEDC", name: "Ikeja Electric" },
    { code: "EKEDC", name: "Eko Electric" },
    { code: "AEDC", name: "Abuja Electric" },
    { code: "KEDC", name: "Kano Electric" },
    { code: "JEDC", name: "Jos Electric" },
    { code: "IBEDC", name: "Ibadan Electric" },
    { code: "KAEDC", name: "Kaduna Electric" },
    { code: "EEDC", name: "Enugu Electric" },
    { code: "PhED", name: "Port Harcourt Electric" },
    { code: "BEDC", name: "Benin Electric - BEDC" },
    { code: "ABA", name: "Aba Power Electric - ABA" },
    { code: "YEDC", name: "Yola Electricity Distribution Company - YEDC" },
];

const ElectricityPayment = () => {
    const { verifyElectricityCustomer } = useContext(AuthContext);
    const navigate = useNavigate();

    const [service, setService] = useState("");
    const [meterNumber, setMeterNumber] = useState("");
    const [meterType] = useState("PRE"); // Prepaid only
    const [amount, setAmount] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [errors, setErrors] = useState({});
    const serviceRef = useRef(null);
    const meterRef = useRef(null);
    const amountRef = useRef(null);

    useEffect(() => {
        const autoVerify = async () => {
            if (service && meterNumber.length === 11) {
                setLoading(true);
                setErrors({});
                setCustomerName("");
                setAccessToken("");

                const res = await verifyElectricityCustomer(service, meterNumber, meterType);

                if (res?.error) {
                    setErrors({ meterNumber: res.description || res.error });
                    setCustomerName("");
                    setAccessToken("");
                } else {
                    setCustomerName(res.customerName || "Customer Verified");
                    setAccessToken(res.accessToken || "");
                }

                setLoading(false);
            } else {
                setCustomerName("");
                setAccessToken("");
            }
        };

        autoVerify();
    }, [meterNumber, service]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = {};

        if (!service) {
            newErrors.service = "Please select a service.";
        }

        if (!meterNumber || meterNumber.length !== 11) {
            newErrors.meterNumber = "Meter number must be exactly 11 digits.";
        }

        if (!accessToken) {
            newErrors.meterNumber = "Please verify the meter number.";
        }

        if (!amount) {
            newErrors.amount = "Please enter an amount.";
        } else if (parseInt(amount) < 1000 || parseInt(amount) > 10000) {
            newErrors.amount = "Amount must be between ₦1,000 and ₦10,000.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);

            // Scroll to first error
            if (newErrors.service) serviceRef.current.scrollIntoView({ behavior: "smooth" });
            else if (newErrors.meterNumber) meterRef.current.scrollIntoView({ behavior: "smooth" });
            else if (newErrors.amount) amountRef.current.scrollIntoView({ behavior: "smooth" });

            return;
        }

        setErrors({});

        navigate("/review", {
            state: {
                type: "electricity",
                details: {
                    service,
                    meterNumber,
                    meterType,
                    accessToken,
                    customerName,
                    amount,
                },
            },
        });
    };

    return (
        <div className="electricity-container">
            <form onSubmit={handleSubmit} className="electricity-form">
                <div className="elect-form-group" ref={serviceRef}>
                    <label htmlFor="service-select" className="styled-label network-label">
                        Electricity Provider
                    </label>
                    <select
                        id="service-select"
                        value={service}
                        onChange={(e) => setService(e.target.value)}
                        className="styled-select styled-label"
                    >
                        <option value="">-- Select Service --</option>
                        {electricityServices.map(({ code, name }) => (
                            <option key={code} value={code}>
                                {name}
                            </option>
                        ))}
                    </select>
                    {errors.service && <p className="error-input">{errors.service}</p>}
                </div>



                <div className="elect-form-group" ref={meterRef}>
                    <label htmlFor="meter-number" className="styled-label network-label">
                        Meter Number
                    </label>
                    <input
                        id="meter-number"
                        type="text"
                        inputMode="numeric"
                        maxLength={11}
                        value={meterNumber}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setMeterNumber(value);
                        }}
                        className="form-input styled-input airtime-input"
                    />
                    {customerName && <p className="verified-text">{customerName}</p>}
                    {errors.meterNumber && <p className="error-input">{errors.meterNumber}</p>}
                </div>

                <div className="elect-form-group" ref={amountRef}>
                    <label htmlFor="amount" className="styled-label network-label">
                        Amount (₦)
                    </label>
                    <input
                        className="styled-input airtime-input"
                        type="text"
                        inputMode="numeric"
                        maxLength={5}
                        value={amount}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setAmount(value);
                        }}
                    />
                    {errors.amount && <p className="error-input">{errors.amount}</p>}
                </div>


                <div className="flex space-x-2">

                    <button
                        type="submit"
                        disabled={loading || !accessToken}
                        className="review-button"
                    >
                        {loading ? "Preparing..." : "Review Payment"}
                    </button>

                </div>

                <div className="">
                    <Link to="/electricity-details" className="token-widget-link">
                        <div className="token-widget-box">
                            <span className="token-title">
                                <FaBolt className="token-icon" /> View Electricity Token History
                            </span>
                            <span className="token-arrow">
                                <FaArrowRight />
                            </span>
                        </div>
                    </Link>
                </div>
            </form>
        </div>
    );
};

export default ElectricityPayment;
